import React from 'react'
import PropTypes from 'prop-types'
import { T } from 'ramda'
import { useSelector } from 'react-redux'

import { useStyles } from './voucher-validate-error.styles'
import exclamationWhiteSmall from '../../../../images/exclamation-white-small.svg'
import { useVoucherValidateError } from '../../../modules/add-subscription-modal/hooks/use-voucher-validate-error'
import Button from '../../button'
import {
  VOUCHER_VALIDATE_AFTER_LOGIN_WITH_PLAN
} from '../../../constants'

/**
 * Displays a voucher validation error (voucher does not match the selected plan)
 * and provides context-specific actions to go back, change the selected plan,
 * or continue without the voucher.
 */
const VoucherValidateErrorModal = ({ type, renderStep }) => {
  const styles = useStyles()
  const error = useSelector(state => state.voucherValidateError)
  const { changePlanHandler, skipVoucherHandler } = useVoucherValidateError(type)

  return (
    <div className={styles.voucherContainer}>
      <div className={styles.iconFrame}>
        <img
          src={exclamationWhiteSmall}
          alt="exclamation"
        />
      </div>

      <div className={styles.title}>
        This voucher isn&apos;t valid for this Plan
      </div>

      <p className={styles.errorMessage}>
        {error}
      </p>

      <div className={styles.buttonContainer}>
        {
          type === VOUCHER_VALIDATE_AFTER_LOGIN_WITH_PLAN ? (
            <Button
              onClick={() => renderStep(1)}
              className={styles.button}
              text="Go Back"
            />
          ) : (
            <div className={styles.buttons}>
              <Button
                onClick={changePlanHandler}
                className={styles.button}
                text="Change Plan"
              />
              <Button
                onClick={skipVoucherHandler}
                className={styles.button}
                text="Skip"
                darkBGSecondary
              />
            </div>
          )
        }
      </div>
    </div>
  )
}

VoucherValidateErrorModal.propTypes = {
  type: PropTypes.string.isRequired,
  renderStep: PropTypes.func
}

VoucherValidateErrorModal.defaultProps = {
  renderStep: T
}

export default VoucherValidateErrorModal
